export default __webpack_public_path__ + "static/media/Icon-Check_Gray.109de8c1.svg";